import { render, staticRenderFns } from "./OrganizationAddPermission.vue?vue&type=template&id=432a7512&"
import script from "./OrganizationAddPermission.vue?vue&type=script&lang=js&"
export * from "./OrganizationAddPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports